class EventDispatcher {
  constructor() {
    this._listeners = {}
  }

  on(event, callback) {
    const listeners = this._listeners[event] || [];

    listeners.push(callback);

    this._listeners[event] = listeners;
  }

  off(event, callback) {
    const all = this._listeners[event] || [];
    let listeners = all.filter((listener) => listener !== callback);

    this._listeners[event] = listeners;
  }

  dispatch(event, ...rest) {
    const listeners = this._listeners[event] || [];

    listeners.forEach(function (fn) {
      fn(...rest);
    });
  }
}

export default EventDispatcher;
